import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarRatingProps {
  count?: number;
  className?: string;
  size?: number;
  label?: string;
}
export function StarRating({
  count = 5,
  className = '',
  size = 18,
  label = 'Calificación 5 de 5 estrellas'
}: StarRatingProps) {
  return <div className={`flex items-center gap-0.5 ${className}`} role="img" aria-label={label} data-id="element-261">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} width={size} height={size} className="fill-gold text-gold" aria-hidden="true" data-id="element-262" />)}
    </div>;
}